// api.js
import axios from "axios";

// Base URL of your backend
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Function to add a new challenge
export const addChallenge = async (challengeData) => {
  try {
    const response = await axios.post(
      `${BACKEND}/postChallenges`,
      challengeData,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads
        },
      })
    
    return response.data;
  } catch (error) {
    console.error("Error adding challenge:", error);
    throw error;
  }
};

export const getChallenges = async () => {
  try {
    const response = await axios.get(`${BACKEND}/getChallenges`);
    return response.data;
  } catch (error) {
    console.error("Error fetching challenges:", error);
    throw error;
  }
};

export const togglePublish = async (challengeId) => {
  try {
    const { data } = await axios.patch(
      `${BACKEND}/toggle-publish/${challengeId}`
    );
    return data.challenge; // Returning updated challenge object
  } catch (error) {
    throw new Error("Error toggling publish status");
  }
};

export const deleteChallenge = async (id) => {
  const token = localStorage.getItem("token");
  console.log("challengeid", id);
  try {
    const response = await axios.delete(`${BACKEND}/deleteChallenge/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error while deleting the challenge", error);
    throw error;
  }
};

// Function to update an existing challenge
export const updateChallenge = async (challengeId, challengeData) => {
  try {
    const response = await axios.put(`${BACKEND}/updatechallenge/${challengeId}`, challengeData);
    return response.data;
  } catch (error) {
    console.error('Error updating challenge:', error);
    throw error;
  }
};

export const getSubmittedChallenges = async (challengeId) => {
  try {
    const response = await axios.get(`${BACKEND}/getsubmittedchallenges/${challengeId}`); // Pass challengeId in the URL
    return response;
  } catch (error) {
    console.error("Error fetching challenges:", error);
    throw error;
  }
};
export const approveRequest = async (studentId, challengeId) => {
  try {
    const response = await axios.put(`${BACKEND}/approverequest`, {studentId, challengeId});
    return response.data;
  } catch (error) {
    console.error('Error updating challenge:', error);
    throw error;
  }
};

export const rejectRequest = async (studentId, challengeId) => {
  try {
    const response = await axios.put(`${BACKEND}/rejectrequest`, {studentId, challengeId});
    return response.data;
  } catch (error) {
    console.error('Error updating challenge:', error);
    throw error;
  }
};







